import { StateSchema } from 'app/config/storeConfig/types';
import { InsuranceFormDrawerSchema } from '../types';

export const getInsuranceFormState = (state: StateSchema): InsuranceFormDrawerSchema => state.insuranceFormDrawer;
